import React, { memo } from 'react';
import { getPageProps } from '@kibt/krn-utils';
import { radar } from '../log';

// 判读是否是首图
let isFirstImageUploaded = false;

function withImageWrapper<T>(ImageComponent: T): T {
    const ImageType = ['webp', 'unknown', 'png', 'jpeg', 'jpg', 'svg', 'gif'];
    const imageWrapper = memo((props: any) => {
        const { onCreateTimestamp } = getPageProps();
        const { onLoad, onLoadStart } = props;
        let startLoadTime = 0;
        // 非标记为首图直接返回原组件
        if (props.kWaiFirstImage !== true) {
            return <ImageComponent {...props} />;
        }

        const newOnLoadStart = e => {
            onLoadStart && onLoadStart(e);
            if (onCreateTimestamp && !isFirstImageUploaded) {
                startLoadTime = Date.now();
            }
        };

        const newOnload = e => {
            onLoad && onLoad(e);
            if (onCreateTimestamp > 0 && !isFirstImageUploaded) {
                isFirstImageUploaded = true;
                const type = props?.source?.uri ? props?.source?.uri.split('.').pop() : 'unknown';
                const params = {
                    duration: Date.now() - onCreateTimestamp,
                    startLoadDuration: startLoadTime - onCreateTimestamp,
                    imageDuration: Date.now() - startLoadTime,
                    url: props?.source?.uri,
                    type: ImageType.includes(type) ? type : 'unknown',
                };
                radar.event({
                    name: 'SHOP_KRN_FIRST_IMAGE_LOAD',
                    params,
                });

                console.log('firstImage =>', params);
            }
        };

        return <ImageComponent {...props} onLoadStart={e => newOnLoadStart(e)} onLoad={e => newOnload(e)} />;
    });

    return imageWrapper;
}

export default withImageWrapper;
